var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F7F8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 9.24121C15.1582 9.86556 14.9691 10.3965 14.5908 10.834C14.2126 11.2715 13.6816 11.5723 12.998 11.7363V11.7773C13.8047 11.8776 14.4154 12.1237 14.8301 12.5156C15.2448 12.903 15.4521 13.4271 15.4521 14.0879C15.4521 15.0495 15.1035 15.7992 14.4062 16.3369C13.709 16.8701 12.7132 17.1367 11.4189 17.1367C10.3343 17.1367 9.37272 16.9567 8.53418 16.5967V14.7988C8.92155 14.9948 9.34766 15.1543 9.8125 15.2773C10.2773 15.4004 10.7376 15.4619 11.1934 15.4619C11.8906 15.4619 12.4056 15.3434 12.7383 15.1064C13.071 14.8695 13.2373 14.4889 13.2373 13.9648C13.2373 13.4954 13.0459 13.1628 12.6631 12.9668C12.2803 12.7708 11.6696 12.6729 10.8311 12.6729H10.0723V11.0527H10.8447C11.6195 11.0527 12.1846 10.9525 12.54 10.752C12.9001 10.5469 13.0801 10.1982 13.0801 9.70605C13.0801 8.94954 12.6061 8.57129 11.6582 8.57129C11.3301 8.57129 10.9951 8.62598 10.6533 8.73535C10.3161 8.84473 9.9401 9.03385 9.52539 9.30273L8.54785 7.84668C9.45931 7.19043 10.5462 6.8623 11.8086 6.8623C12.8431 6.8623 13.6589 7.07194 14.2559 7.49121C14.8574 7.91048 15.1582 8.49382 15.1582 9.24121Z",
    fill: "parent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeIcon);
export default __webpack_public_path__ + "static/media/ThreeIcon.f76ba5567c29468213845d4d9a403364.svg";
export { ForwardRef as ReactComponent };